var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#F2F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6978 7.64447H6.10246C5.52188 7.64447 5.05123 8.20164 5.05123 8.88894V15.1113C5.05123 15.7986 5.52188 16.3558 6.10246 16.3558H14.6978C15.2784 16.3558 15.749 15.7986 15.749 15.1113V8.88894C15.749 8.20164 15.2784 7.64447 14.6978 7.64447ZM6.10246 6.4C4.9413 6.4 4 7.51434 4 8.88894V15.1113C4 16.4859 4.9413 17.6002 6.10246 17.6002H14.6978C15.859 17.6002 16.8003 16.4859 16.8003 15.1113V8.88894C16.8003 7.51434 15.859 6.4 14.6978 6.4H6.10246Z",
    fill: "#26CD58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9714 9.36939C18.9714 9.2226 18.8347 9.12824 18.7205 9.19628L16.3205 10.6268C16.2639 10.6605 16.2285 10.7272 16.2285 10.7999V13.2685C16.2285 13.3426 16.2653 13.4103 16.3235 13.4434L18.7235 14.8058C18.8375 14.8705 18.9714 14.776 18.9714 14.6309V9.36939ZM18.2438 8.15761C19.0428 7.68138 20 8.34186 20 9.36939V14.6309C20 15.6466 19.0627 16.3078 18.2649 15.855L15.8649 14.4926C15.4574 14.2613 16.8009 14.0001 15.9999 13.2685V10.7999C16.8007 9.60005 15.448 9.82405 15.8437 9.58814L18.2438 8.15761Z",
    fill: "#26CD58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5646 1.90455L19.9999 7.53306",
    stroke: "#434A51",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5646 21.8188L19.9999 16.1903",
    stroke: "#434A51",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMarker);
export default __webpack_public_path__ + "static/media/cameraMarker.08158b944aad6a6fdcb2f9afe7dd6423.svg";
export { ForwardRef as ReactComponent };